export var LinkTarget;
(function (LinkTarget) {
    LinkTarget[LinkTarget["NONE"] = 0] = "NONE";
    LinkTarget[LinkTarget["SELF"] = 1] = "SELF";
    LinkTarget[LinkTarget["BLANK"] = 2] = "BLANK";
    LinkTarget[LinkTarget["PARENT"] = 3] = "PARENT";
    LinkTarget[LinkTarget["TOP"] = 4] = "TOP";
})(LinkTarget || (LinkTarget = {}));
//# sourceMappingURL=pdfjs-dist.type.js.map